import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { FilterAttributeRange } from '@df/catalog-ui/listing/filter/filter-attribute-range';
surviveTreeShaking(FilterAttributeOption, FilterAttributeRange);
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { Subscription } from 'rxjs';
import { Product } from '../product/product.decorator';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';


@Component({
    selector: 'product-listing-tools',
    templateUrl: 'product-listing-tools.html',
    styleUrls: ['product-listing-tools.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingToolsComponent implements OnChanges, OnDestroy {
    /**
     * Component subscriptions
     */
    private subscription?: Subscription;

    /**
     * Listing instnace
     */
    @Input()
    listing?: ProductListing<Product<IProductDataV2>>;

    @Input()
    filtersOpen = false;

    /**
     * Dependencies
     */
    constructor(
        readonly client: Client,
        private changeDetectorRef: ChangeDetectorRef,
        protected app: App
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['listing']?.currentValue) {
            this.subscription?.unsubscribe();
            this.subscription = this.listing?.subscribe(() => this.changeDetectorRef.detectChanges());
        }
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    getFiltersForChips(): FilterAttributeOption<any>[] {
        return this.listing?.getFiltersWithSelection().filter(i => i.filterType === 'attribute-option') as FilterAttributeOption<any>[];
    }

    protected resetFilters(): void {
        this.listing?.resetFilters();
    }
}
